import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BrandingService {
  private logoUrl$ = new BehaviorSubject<string>(sessionStorage.getItem('logoUrl') ?? '');
  private imgLogin$ = new BehaviorSubject<string>(sessionStorage.getItem('imgLogin') ?? '');
  private imgLoginMobile$ = new BehaviorSubject<string>(sessionStorage.getItem('imgLoginMobile') ?? '');
  private logoAlt$ = new BehaviorSubject<string>(sessionStorage.getItem('logoAlt') ?? '');

  readonly logoUrl = this.logoUrl$.asObservable();
  readonly imgLogin = this.imgLogin$.asObservable();
  readonly imgLoginMobile = this.imgLoginMobile$.asObservable();
  readonly logoAlt = this.logoAlt$.asObservable();

  update(data: {
    logoUrl: string;
    imgLogin: string;
    imgLoginMobile: string;
    logoAlt: string;
  }) {
    this.logoUrl$.next(data.logoUrl);
    this.imgLogin$.next(data.imgLogin);
    this.imgLoginMobile$.next(data.imgLoginMobile);
    this.logoAlt$.next(data.logoAlt);
  }
}
